
export default {
    // getaccesstoken(params) {
    //     // 通过"refreshtoken"换取"accesstoken"
    //     var rtoken, queryobj = app.tool.parseQuery();
    //     if (queryobj.refreshtoken) {
    //         app.ls.set("refreshtoken", decodeURIComponent(queryobj.refreshtoken))
    //     }

    //     rtoken = app.ls.get("refreshtoken")

    //     return app.http.ajax({
    //         url: 'getaccesstoken',
    //         data: {
    //             refreshtoken: rtoken,
    //             businesstype: 3
    //         }
    //     }).then(res => {
    //         if (res.result.code == 200) {
    //             app.http.accesstoken = res.data.accesstoken
    //             return app.http.accesstoken
    //         } else {
    //             location.replace(res.data.redirecturl)
    //             console.log(res);
    //         }
    //     })
    // },
    // 获取微信jssdk配置_伍志长
    getWxJsConfig(params) {
        return app.http.ajax({
            method: "get",
            url: "/mall-portal/common/getWxJsConfig",
            params,
        });
    },
}